<template>
    <div :class="getCssClass(value)">
        {{name}}
    </div>  
</template>

<script>
export default {
    props: ['value', 'mega', 'type', 'name'],
    data() {
        return {
            effectLabels: [
                {
                    labelClass: 'label label--green',
                    textClass: 'text--green'
                },
                {
                    labelClass: 'label label--red',
                    textClass: 'text--red'
                },
                {
                    labelClass: 'label label--yellow',
                    textClass: 'text--yellow'
                },
                {
                    labelClass: 'label label--gray',
                    textClass: 'text--gray'
                },
                {
                    labelClass: 'label label--gray',
                    textClass: 'text--gray'
                }
            ]
        }
    },
    methods: {
        getCssClass(value) {
            var cssClass = (this.type !== 'text') ? this.effectLabels[value].labelClass : this.effectLabels[value].textClass;
            return (this.mega) ? cssClass + ' label--mega' : cssClass;
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/EffectLabel.vue